import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import add_file from "../../Assets/add_file.png";
import template from "../../Assets/template.png";
import links from "../../Assets/links.png";

const styles = {
  container: {
    textAlign: "center",
    py: { xs: 6, md: 8 },
  },
  sectionTitle: {
    fontWeight: "bold",
    fontSize: { xs: "1.8rem", md: "2.5rem" },
    color: "#1662A7",
    mb: { xs: 4, md: 6 },
    maxWidth: "800px",
    mx: "auto",
  },
  featureCard: {
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "translateY(-5px)",
    },
  },
  featureImage: {
    width: "95%",
    maxWidth: "300px",
    borderRadius: "12px",
    boxShadow: "0px 6px 25px rgba(0, 0, 0, 0.1)",
    mb: 3,
  },
  featureText: {
    fontWeight: "medium",
    fontSize: { xs: "1rem", md: "1.3rem" },
    color: "#25B2E8",
    textAlign: "center",
    lineHeight: 1.4,
    px: 2,
  },
};

const FEATURES = [
  { src: add_file, text: "Uploading existing PDF files" },
  { src: template, text: "Assign areas to complete" },
  { src: links, text: "Create public web link" },
];

const FeatureCard = ({ src, text }) => (
  <Grid item xs={12} md={4}>
    <Box sx={styles.featureCard}>
      <Stack alignItems="center" spacing={2}>
        <Box component="img" src={src} alt={text} sx={styles.featureImage} />
        <Typography sx={styles.featureText}>{text}</Typography>
      </Stack>
    </Box>
  </Grid>
);

function UploadingAndFormatting() {
  return (
    <Box sx={{ backgroundColor: "#ffffff" }}>
      <Container maxWidth="lg" sx={styles.container}>
        <Typography variant="h2" sx={styles.sectionTitle}>
          Uploading & Formatting Documents
        </Typography>

        <Grid container spacing={4}>
          {FEATURES.map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default UploadingAndFormatting;
